import script from "./resourcesVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./resourcesVideo.vue?vue&type=script&setup=true&lang=js"

import "./resourcesVideo.vue?vue&type=style&index=0&id=177658e3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177658e3"]])

export default __exports__